module.exports = __webpack_public_path__ + "img/tu1.38874e1c.png";